const PUBLIC_ADMIN_AUTH_PATHS = new Set(['/login', '/forgot-password', '/change-password']);

const ADMIN_PASSWORD_FIRST_ACCESS_MESSAGE =
    'Cadastro concluído. No primeiro acesso, o novo administrador deve usar “Esqueci minha senha” na tela de login.';

function isPublicAdminAuthPath(url = '') {
    return PUBLIC_ADMIN_AUTH_PATHS.has(url.split('?')[0]);
}

function isValidAdminPassword(password = '') {
    return (
        password.length >= 8 &&
        password.length <= 72 &&
        /[a-z]/.test(password) &&
        /[A-Z]/.test(password) &&
        /\d/.test(password)
    );
}

module.exports = {
    ADMIN_PASSWORD_FIRST_ACCESS_MESSAGE,
    isPublicAdminAuthPath,
    isValidAdminPassword,
};
